<mat-horizontal-stepper [linear]="true" #stepper>

  <mat-step [stepControl]="horizontalForm">
    <ng-template matStepLabel i18n>Single horizontal</ng-template>
    <div class="form-contents">

      <h2 i18n>Single horizontal property</h2>

      <app-balanced-unbalanced-toggle [value]="parameters.horizontal_settings.network_type"
        (valueChange)="horizontalBalancedUnbalancedToggle($event)">
      </app-balanced-unbalanced-toggle>

      <ng-container *ngIf="parameters.horizontal_settings.network_type === 'balanced'">
        <app-horizontal-balanced-form [(parameters)]="parameters" [parentForm]="horizontalForm">
        </app-horizontal-balanced-form>
      </ng-container>
      <ng-container *ngIf="parameters.horizontal_settings.network_type === 'unbalanced'">
        <app-horizontal-unbalanced-form [(parameters)]="parameters" [parentForm]="horizontalForm">
        </app-horizontal-unbalanced-form>
      </ng-container>
    </div>
    <div class="action-buttons">
      <mat-action-row>
        <button type="button" [disabled]="horizontalForm.invalid || !parameters.horizontal_settings.network_type"
          mat-stroked-button matStepperNext i18n>NEXT</button>
      </mat-action-row>
    </div>

  </mat-step>

  <mat-step>
    <ng-template matStepLabel i18n>Single horizontal diagram</ng-template>
    <div class="form-contents">
      <ng-container *ngIf="stepper.selectedIndex === 1">
        <app-diagram-horizontal [horizontalSettings]="parameters.horizontal_settings"></app-diagram-horizontal>
      </ng-container>
    </div>
    <mat-action-row>
      <button type="button" mat-button matStepperPrevious i18n>BACK</button>
      <button type="button" mat-stroked-button matStepperNext i18n>NEXT</button>
    </mat-action-row>
  </mat-step>

  <mat-step [stepControl]="horizontalCollectiveForm">

    <ng-template matStepLabel i18n>Collective horizontal</ng-template>
    <div class="form-contents">
      <ng-container *ngIf="stepper.selectedIndex === 2">
        <h2 i18n>Collective horizontal property</h2>
        <app-horizontal-collective-units-by-type [parameters]="parameters" [parentForm]="horizontalCollectiveForm">
        </app-horizontal-collective-units-by-type>
      </ng-container>
    </div>
    <mat-action-row>
      <button type="button" mat-button matStepperPrevious i18n>BACK</button>
      <button type="button" mat-stroked-button matStepperNext [disabled]="horizontalCollectiveForm.invalid"
        i18n>NEXT</button>
    </mat-action-row>
  </mat-step>

  <mat-step>

    <ng-template matStepLabel i18n>Collective horizontal diagram</ng-template>

    <ng-container>
      <div class="form-contents">
        <ng-container *ngIf="stepper.selectedIndex === 3">
          <app-diagram-group [types]="this.parameters.horizontal_collective_settings.types"></app-diagram-group>
        </ng-container>
      </div>
    </ng-container>

    <div class="action-buttons">
      <mat-action-row>
        <button type="button" mat-button matStepperPrevious i18n>BACK</button>
        <button type="button" mat-stroked-button matStepperNext i18n>NEXT</button>
      </mat-action-row>
    </div>
  </mat-step>

  <mat-step [stepControl]="verticalForm">

    <ng-template matStepLabel i18n>Collective vertical</ng-template>
    <div class="form-contents">
      <ng-container *ngIf="stepper.selectedIndex === 4">
        <h2 i18n>Collective vertical property</h2>
        <app-vertical-units-by-type [parameters]="parameters" [parentForm]="verticalForm">
        </app-vertical-units-by-type>
      </ng-container>
    </div>
    <mat-action-row>
      <button type="button" mat-button matStepperPrevious i18n>BACK</button>
      <button type="button" mat-stroked-button matStepperNext [disabled]="verticalForm.invalid" i18n>NEXT</button>
    </mat-action-row>
  </mat-step>

  <mat-step #vertical_diagram_step>

    <ng-template matStepLabel i18n>Collective vertical diagram</ng-template>

    <ng-container>
      <div class="form-contents">
        <ng-container *ngIf="stepper.selectedIndex === 5">
          <app-diagram-group [types]="this.parameters.vertical_settings.types"></app-diagram-group>
        </ng-container>
      </div>
    </ng-container>

    <div class="action-buttons">
      <mat-action-row>
        <button type="button" mat-button matStepperPrevious i18n>BACK</button>
        <button type="button" mat-raised-button color="primary" (click)="finish()"
          [disabled]="horizontalForm.invalid || verticalForm.invalid || !parameters.horizontal_settings.network_type"
          i18n>FINISH</button>
      </mat-action-row>
    </div>
  </mat-step>

</mat-horizontal-stepper>
